<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path style="fill:#D80027;" d="M486.598,144.696C445.19,59.065,357.494,0,256,0S66.81,59.065,25.402,144.696L256,166.957
		L486.598,144.696z"/>
	<path style="fill:#D80027;" d="M25.402,367.304C66.81,452.935,154.506,512,256,512s189.19-59.065,230.598-144.696L256,345.043
		L25.402,367.304z"/>
</g>
<path style="fill:#0052B4;" d="M486.598,144.696H25.402C9.128,178.351,0,216.109,0,256s9.128,77.649,25.402,111.304h461.195
	C502.873,333.649,512,295.891,512,256S502.873,178.351,486.598,144.696z"/>
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="89.043"/>
</svg>